import CreditCardAddPayButton from './credit-card-add-pay-button';

export default CreditCardAddPayButton;
